import React, { useCallback, useEffect, useState } from 'react';
import styles from './EvaluationQuestions.module.scss';
import PageTitle from '../../../components/pageTitle/PageTitle';
import Table from '../../../components/table/Table';
import Search from '../../../components/search/Search';
import LoadingOverlay from '../../../components/loadingOverlay/LoadingOverlay';
import axiosClient from '../../../api/axiosClient';
import { useToasts } from '../../../contexts/ToastContext';
import { useNavigate } from 'react-router-dom';

const EvaluationQuestions = () => {
  const navigate = useNavigate();
  const { showToast } = useToasts();
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [search, setSearch] = useState('');
  const [pagination, setPagination] = useState({ current: 1, total: 0, start: 1, end: 1, hasPrev: false, hasNext: false });

  const fetchQuestions = useCallback(async (page = 1) => {
    setIsLoading(true);
    try {
      const params = { page, limit: 10, search };
      const response = await axiosClient.get('/evaluation-questions', { params });
      const responseData = response.data;
      setData(responseData.data || []);
      const totalPages = Math.ceil(responseData.total / responseData.limit);
      setPagination({
        current: responseData.page,
        total: responseData.total,
        start: (responseData.page - 1) * responseData.limit + 1,
        end: Math.min(responseData.page * responseData.limit, responseData.total),
        hasPrev: responseData.page > 1,
        hasNext: responseData.page < totalPages,
      });
    } catch (error) {
      showToast(error.message, 'error');
    } finally {
      setIsLoading(false);
    }
  }, [search, showToast]);

  useEffect(() => {
    fetchQuestions(1);
  }, [fetchQuestions]);

  const handlePageChange = (page) => {
    fetchQuestions(page);
  };

  const columns = [
    {
      header: 'Question',
      render: (row) => (
        <span className={styles.questionLink} onClick={() => navigate(`/evaluation-questions/edit/${row.id}`)}>
          {row.question}
        </span>
      ),
    },
  ];

  return (
    <>
      {isLoading && <LoadingOverlay />}
      <div className={styles.header}>
        <PageTitle label="Evaluation Questions" />
        <Search onSubmit={setSearch} />
      </div>
      <div className={styles.container}>
        <Table
          columns={columns}
          data={data}
          emptyMessage="No evaluation questions found."
          pagination={pagination}
          onPageChange={handlePageChange}
        />
      </div>
    </>
  );
};

export default EvaluationQuestions;
